function HeaderMenu() {
    return (
        <div className="header_main">
            <ul className="header_menu">
                <li className="header_menu_item">
                    <a href="#FW10000"><b>FW</b>10000</a>
                </li>
                <li className="header_menu_item">
                    <a href="#FW1800"><b>FW</b>1800</a>
                </li>
                <li className="header_menu_item">
                    <a href="#FD01"><b>FD</b>01</a>
                    <a href="#FD02"><b>FD</b>02</a>
                </li>
                <li className="header_menu_item">
                    <a href="#FW7"><b>FW</b>7</a>
                    <a href="#FW01"><b>FW</b>01</a>
                </li>
                <li className="header_menu_item">
                    <a href="#FW02"><b>FW</b>02</a>
                </li>
                <li className="header_menu_item">
                    <a href="#FW03"><b>FW</b>03</a>
                </li>
                <li className="header_menu_item">
                    <a href="#FW1000T"><b>FW</b>1000T</a>
                </li>
                <li className="header_menu_item">
                    <a href="#SW01"><b>SW</b>01</a>
                </li>
                <li className="header_menu_item">
                    <a href="#SW02"><b>SW</b>02</a>
                </li>
                <li className="header_menu_item">
                    <a href="#S91N"><b>S</b>91N</a>
                </li>
            </ul>
        </div>
    )
}
export default HeaderMenu;